var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBLueRightWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1250,
    height: 133,
    viewBox: "0 0 1250 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 133H1250V106.363L1190.01 82.6134C1130.01 58.8634 1010.02 11.3634 890.031 1.86345C770.042 -7.63655 650.052 20.8634 530.062 49.3634C410.073 77.8634 290.083 106.363 170.093 120.613C111.008 127.63 51.9221 131.192 0 133Z",
    fill: "#3C73FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBLueRightWave);
export default __webpack_public_path__ + "static/media/BLueRightWave.79106a41e6127e80a18c61a19a13909a.svg";
export { ForwardRef as ReactComponent };